import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase3 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: '2024-01-01',
                    sum_daily_active_users: 28780181,
                    new_users: 1383600,
                    revenue_gross_usd: 9188829.71,
                    inapp_revenue_gross_usd: 8121929.01,
                    ad_revenue_gross_usd: 1066900.7,
                    revenue_gross_pln: 36915082.45,
                    inapp_revenue_gross_pln: 32632527.67,
                    ad_revenue_gross_pln: 4282554.79,
                    revenue_net_usd: 6312468.77,
                    inapp_revenue_net_usd: 5245568.07,
                    ad_revenue_net_usd: 1066900.7,
                    revenue_net_pln: 25361444.55,
                    inapp_revenue_net_pln: 21078889.76,
                    ad_revenue_net_pln: 4282554.79,
                    cnt_first_transaction: 129419,
                    transactions: 1209809,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.28,
                    inapp_wavg_ARPDAU_gross_pln: 1.13,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.88,
                    inapp_wavg_ARPDAU_net_pln: 0.73,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0285,
                },
                {
                    date: '2025-01-01',
                    sum_daily_active_users: 74310011,
                    new_users: 4029485,
                    revenue_gross_usd: 25744725.14,
                    inapp_revenue_gross_usd: 23021131.39,
                    ad_revenue_gross_usd: 2723593.75,
                    revenue_gross_pln: 97980449.34,
                    inapp_revenue_gross_pln: 87620434.59,
                    ad_revenue_gross_pln: 10360014.75,
                    revenue_net_usd: 17702292.32,
                    inapp_revenue_net_usd: 14978698.57,
                    ad_revenue_net_usd: 2723593.75,
                    revenue_net_pln: 67374450.33,
                    inapp_revenue_net_pln: 57014435.58,
                    ad_revenue_net_pln: 10360014.75,
                    cnt_first_transaction: 371028,
                    transactions: 3332571,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.32,
                    inapp_wavg_ARPDAU_gross_pln: 1.18,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.91,
                    inapp_wavg_ARPDAU_net_pln: 0.77,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0297,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
